import { AnimatedComponent, AntdTable, DeleteConfirmationModal } from "@/components/common";
import { useDeletePayment, useGetAllPayments, useUpdatePayment } from "@/hooks/query-hooks/usePayments";
import { useNotificationStore } from "@/states/zustand/notification";
import { Divider, Image, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { Helmet } from 'react-helmet-async';
import { AddNewPaymentModal } from "./AddNewPaymentModal";
import { EditPaymentModal } from "./EditPaymentModal";

export function Payments() {

    const { data, isLoading } = useGetAllPayments();

    const { mutate, isMutating } = useDeletePayment();

    const { mutate: publishPayment, isMutating: isPublishing } = useUpdatePayment();

    const columns: ColumnsType<Payment> = [
        {
            title: "Logo",
            dataIndex: "imageUrl",
            render: (value) => (
                <>
                    <Image
                        src={value}
                        alt="Payment Logo"
                        width={48}
                        height={48}
                        className="rounded-sm object-cover"
                    />
                </>
            )
        },
        {
            title: "Payment Name",
            dataIndex: "paymentType",
            key: "paymentType",
        },
        {
            title: "Account Name / Payment Username",
            dataIndex: "accName",
            key: "accName",
        },
        {
            title: "Account Number / Payment Mobile Number",
            dataIndex: "accNo",
            key: "accNo",
        },
        {
            title: "Published",
            dataIndex: "published",
            key: "published",
            render: (published, record) => (
                <>
                    <Switch
                        checked={published}
                        onChange={(checked) => {
                            const formData = new FormData();
                            formData.append("data", new Blob([JSON.stringify({ published: checked })], { type: "application/json" }));

                            const payload = {
                                id: record.id,
                                data: formData
                            };
                            publishPayment(payload, {
                                onSuccess: () => {
                                    useNotificationStore.getState().setNotification({
                                        type: "success",
                                        message: `Payment method ${checked ? "published" : "unpublished"} successfully!`,
                                    })
                                }
                            });
                        }}
                        loading={isPublishing}
                        size="default"
                        disabled={record.paymentType === "Cash"}
                    />
                </>
            )
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <>
                    <EditPaymentModal
                        payment={record}
                    />
                    <DeleteConfirmationModal
                        onDelete={() => mutate(record.id)}
                        isDeleting={isMutating}
                        title="Delete payment method?"
                        description="Please confirm if you want to proceed with the deletion."
                        buttonProps={{
                            disabled: record.paymentType === "Cash"
                        }}
                    />
                </>
            )
        }
    ]

    return (
        <AnimatedComponent>
            <Helmet>
                <title>Payment Methods</title>
            </Helmet>
            <article
                className="flex items-center justify-between "
            >
                <h2
                    className="text-2xl font-semibold text-primary-gradient font-poppins "
                >
                    Payment Methods
                </h2>
                <AddNewPaymentModal />
            </article>
            <Divider />
            <AntdTable
                dataSource={data ?? []}
                columns={columns}
                rowKey={(record) => record.id.toString()}
                loading={isLoading}
            />
        </AnimatedComponent>
    )
}
